import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ImageService {
  constructor() {}

  resizeImage(file: File, callback: (resizedImage: HTMLImageElement) => void) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Defina as novas dimensões da imagem
        const maxWidth = 800; // Defina o tamanho máximo que deseja
        const maxHeight = 800;

        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round(height * (maxWidth / width));
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round(width * (maxHeight / height));
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        // Redimensiona a imagem para o novo tamanho
        ctx?.drawImage(img, 0, 0, width, height);

        // Retorna a imagem redimensionada como resultado
        const resizedImage = new Image();
        resizedImage.src = canvas.toDataURL("image/png");
        resizedImage.onload = () => {
          callback(resizedImage);
        };
      };
      img.src = event.target?.result as string;
    };
    reader.readAsDataURL(file);
  }
}
